import SelectBox from 'devextreme-react/select-box';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import { select_lop } from '../../api/common_api_combo';
import { lopApi } from '../../api/lop_api';
import { useCommonContext } from '../../contexts/common';
export default ({
	value,
	onValueChanged,
	cmb,
	namHoc,
	dm_truong_id,
	dm_khoi_id,
	dm_he_id,
	showClearButton, 
	is_readonly,
	width,
}) => {
	const [dm_lops, set_dm_lops] = useState([]);
	const { nam_hoc } = useSelector((x) => x.namHoc);
	const { translate } = useCommonContext();
	useEffect(() => {
		(async () => {
			let res = null;
			if (dm_khoi_id > 0 && dm_he_id > 0) {
				namHoc = namHoc != undefined || namHoc != '' ? namHoc : nam_hoc;
				res = await lopApi.SelectByNamHoc(namHoc);
				if (res.is_success) {
					if(dm_truong_id > 0){
						res.data = res.data.filter(
							(x) => x.dm_truong_id == dm_truong_id && x.dm_khoi_id == dm_khoi_id && x.dm_he_id == dm_he_id
						);
					}else{
						res.data = res.data.filter(
							(x) => x.dm_khoi_id == dm_khoi_id && x.dm_he_id == dm_he_id
						);
					}
					
					set_dm_lops(res.data);
				} else {
					set_dm_lops([]);
				}
			} else {
				set_dm_lops([]);
			}
		})();
	}, [dm_truong_id, dm_khoi_id, dm_he_id, namHoc]);
	return (
		<SelectBox
			dataSource={dm_lops}
			displayExpr={'ten_lop'}
			valueExpr={'id'}
			value={value}
			readOnly={is_readonly === true ? is_readonly : false}
			stylingMode='outlined'
			ref={cmb}
			placeholder={translate('Chọn lớp')}
			width={width==null?'100%':width}
			showClearButton={showClearButton}
			onValueChanged={(e) => {
				onValueChanged(e.value);
			}}
		/>
	);
};
